define('OutSystems/ClientRuntime/modules/Database/Metadata/MetadataBackupTableInfo',["require", "exports", "tslib", "../TableInfoUtils", "./MetadataTableInfo"], function (require, exports, tslib_1, TableInfoUtils_1, MetadataTableInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var METADATA_BACKUP_TABLE_INFO = tslib_1.__assign(tslib_1.__assign({}, MetadataTableInfo_1.default), { tableName: "" + TableInfoUtils_1.BACKUP_TABLE_PREFIX + TableInfoUtils_1.METADATA_TABLE_NAME });
    exports.default = METADATA_BACKUP_TABLE_INFO;
});
//# sourceMappingURL=MetadataBackupTableInfo.js.map;
